import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IGetLinkResponseDto {
    url: string,
}

export const profileLink = (providerId: number, domain: string): IRequest => ({
    uri: `/api/v1/${providerId}/profile/link`,
    method: 'GET',
    withAuth: true,
    withProvider: true,
    queryParams: { domain },
});
